import { CountryCode } from "@freightsimple/generated-dashboard-openapi-client/models/CountryCode";

// A dangerous-goods shipment falls under Canadian TDG rules when either end is
// in Canada, so the ERAP / TDG-responsible / net-explosive-quantity fields are
// only collected for these shipments. Unlike isDomesticCanada, one end is enough.
export function touchesCanada(
  pickupCountryCode: CountryCode | undefined,
  deliveryCountryCode: CountryCode | undefined,
): boolean {
  return (
    pickupCountryCode === CountryCode.Canada ||
    deliveryCountryCode === CountryCode.Canada
  );
}
